import { Injectable } from '@angular/core'
import { HttpService } from '@surgetech-eu/core'
import { Observable } from 'rxjs'
import { LibraryModel } from '../models'

export const url = '/libraries/management/types/baseMaterialCertificationType/entries'
export interface BaseMaterialCertificationType extends LibraryModel {
    new?: boolean
}
@Injectable({
    providedIn: 'root'
})
export class BaseMaterialCertificationTypeService {
    constructor(private http: HttpService) {}

    getAll(): Observable<BaseMaterialCertificationType[]> {
        return this.http.get<BaseMaterialCertificationType[]>(url)
    }

    remove(data: BaseMaterialCertificationType[]): Observable<void> {
        return this.http.delete(url, { data })
    }

    create(data: BaseMaterialCertificationType[]): Observable<BaseMaterialCertificationType[]> {
        return this.http.post<BaseMaterialCertificationType[]>(url, { data })
    }
    update(data: BaseMaterialCertificationType[]): Observable<BaseMaterialCertificationType[]> {
        return this.http.put<BaseMaterialCertificationType[]>(url, { data })
    }
}
